import { Box, Flex, rem, Skeleton, useMantineTheme } from "@mantine/core";

interface ChatItemSkeletonProps {
  opacity?: number;
}

export default function ChatItemSkeleton({
  opacity = 0.6,
}: ChatItemSkeletonProps) {
  const theme = useMantineTheme();
  return (
    <Flex
      direction="column"
      justify="center"
      align="center"
      gap={16}
      w="100%"
      p={16}>
      {/* Container principal */}
      <Flex
        align="center"
        gap={24}
        w="100%"
        style={{ alignSelf: "stretch" }}>
        {/* Foto de perfil */}
        <Skeleton
          circle
          height={rem(40)}
          opacity={opacity}
        />

        {/* Coluna com nome e última mensagem */}
        <Flex
          direction="column"
          justify="flex-start"
          align="flex-start"
          gap={4}
          style={{ flex: "1 1 0", minWidth: 0 }}>
          {/* Nome do usuário */}
          <Skeleton
            height={8}
            width="60%"
            radius="xl"
            opacity={opacity}
          />

          {/* Última mensagem */}
          <Skeleton
            height={8}
            width="70%"
            radius="xl"
            opacity={opacity}
          />
        </Flex>
      </Flex>

      {/* Borda inferior (para separar os itens de chat) */}
      <Box
        style={{
          borderBottom: `1px solid ${theme.colors.background_1[0]}`,
          width: "100%",
        }}
      />
    </Flex>
  );
}
